<template lang="pug">
  form(@submit.prevent="onFormSubmit")
    .b-user-form
      ._row(v-for="(field, name) in selectedForm" :key="field.label")
        ._label {{ field.label }}
        BaseField._field(
          @change="onFieldChange(name)"
          v-model="field.value"
          :type="field.type"
          :error="field.error"
          :options="field.options"
          )
      ._buttons
        Btn(grey :to="{ name: 'account' }") Отмена
        Btn(green submit) Сохранить
</template>

<script>
import userApi from '@/api/user';

// import timezones from '@/utils/timezones';
import form from '@/utils/form';

import BaseField from '@/components/BaseField.vue';

export default {
  name: 'AccountForm',
  components: { BaseField },
  props: {
    user: Object,
  },
  data() {
    return {
      forms: {
        main: {
          name:     form.createFieldObject('text',     'Имя',     '', { required: 'Укажите имя' } ), // eslint-disable-line
          surname:  form.createFieldObject('text',     'Фамилия', '', { required: 'Укажите имя' } ), // eslint-disable-line
        },
        contacts: {
          notificationsEmail:   form.createFieldObject('email',     'E-mail',   '', { required: 'Укажите почту',    email: 'Почта некорректна'     } ), // eslint-disable-line
          phone:                form.createFieldObject('tel',       'Телефон',  '',                                                                  ), // eslint-disable-line
          skype:                form.createFieldObject('text',      'Skype',                                                                         ), // eslint-disable-line
          telegram:             form.createFieldObject('text',      'Telegram',                                                                      ), // eslint-disable-line
          whatsapp:             form.createFieldObject('text',      'WhatsApp',                                                                      ), // eslint-disable-line
        },
        settings: {
          country:        form.createFieldObject('text',      'Страна',                                                                        ), // eslint-disable-line
          city:           form.createFieldObject('text',      'Город',                                                                         ), // eslint-disable-line
          // timezone:       form.createFieldObject('select',    'Часовой пояс', '', {}, form.makeSelectOptionsFromObject(timezones)              ), // eslint-disable-line
          dateBirth:      form.createFieldObject('date',      'Дата рождения',                                                                 ), // eslint-disable-line
          gender:         form.createFieldObject('select',    'Пол', '', {},   [{ value: 'male', label: 'Мужской' }, { value: 'female', label: 'Женский' }] ), // eslint-disable-line
        },
        security: {
          // oldPassword:    form.createFieldObject('password',  'Текущий пароль',   '', { required: 'Укажите пароль'   }                          ), // eslint-disable-line
          password:       form.createFieldObject('password',  'Новый пароль',     '', { required: 'Укажите пароль'   }                          ), // eslint-disable-line
          repeatPassword: form.createFieldObject('password',  'Повторите пароль', '', { required: 'Повторите пароль', match: { field: 'password', message: 'Пароли не совпадают'} } ), // eslint-disable-line
        },
      },
    };
  },
  computed: {
    selectedForm() {
      return this.forms[this.$route.params.category];
    },
  },
  methods: {
    onFieldChange(fieldName) {
      form.validateField(this.selectedForm, fieldName);
    },
    onFormSubmit() {
      form.validate(this.selectedForm);

      if (form.hasErrors(this.selectedForm)) {
        return;
      }

      const formData = form.getValues(this.selectedForm);

      switch (formData.gender) {
        case 'male': formData.gender = true; break;
        case 'female': formData.gender = false; break;
        case null: formData.gender = null; break;
        default: delete formData.gender; break;
      }

      if (formData.phone === '') {
        formData.phone = null;
      }

      userApi.update(this.user.id, formData, true)
        .then(() => {
          this.$router.push({ name: 'account' });
          document.location.reload();
        })
        .catch((e) => {
          const errors = {
            'This value is already used.': {
              phone: 'Пользователь с таким телефоном уже существует',
              email: 'Пользователь с таким e-mail уже существует',
            },
          };

          e.violations.forEach(({ propertyPath, message }) => {
            const field = this.selectedForm[propertyPath];

            if (!field) {
              return;
            }

            field.error = errors?.[message]?.[propertyPath] ?? 'Неизвестная ошибка';
          });
        });
    },
  },
  mounted() {
    form.setValues(this.selectedForm, this.user);
  },
};
</script>

<style scoped lang="scss">
.user-form {
  display: grid;
  gap: 30px;

  &__row {
    display: grid;
    grid-template-columns: 1fr 5fr;
    column-gap: 30px;
    row-gap: 10px;
    align-items: center;
  }

  &__label {
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: var(--color-middle-gray);
  }

  &__field {
    max-width: 300px;
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  @media (max-width: 1600px) {
    &__row {
      grid-template-columns: 1fr 3fr;
    }
  }

  @media (max-width: 1024px) {
    &__field {
      max-width: none;
    }
  }

  @media (max-width: 576px) {
    &__row {
      grid-template-columns: 1fr;
    }
  }
}
</style>
